export const ExperienceStatuses = {
    PUBLISHED: 'published',
    UNPUBLISHED: 'unpublished',
    ARCHIEVED: 'archieved'
}

export const PricingStrategies = {
    SERVES: 'serves',
    ORDER_COUNT: 'order_count',
    REVENUE_ATTRIBUTION: 'revenue_attribution',
    FLAT: 'flat'
}

export const PlanSlugs = {
    FREE: 'free-recommendations-plan',
    PRO: 'pro',
    SCALE: 'scale'
}

